import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./BenefisUIHelpers";

const BenefisUIContext = createContext();

export function useBenefisUIContext() {
  return useContext(BenefisUIContext);
}

export const BenefisUIConsumer = BenefisUIContext.Consumer;

export function BenefisUIProvider({ benefisUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initBenefis = {
    name: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initBenefis,
    newBenefisIndividuButtonClick:
      benefisUIEvents.newBenefisIndividuButtonClick,
    openEditBenefisIndividualPage:
      benefisUIEvents.openEditBenefisIndividualPage,
    openEditBenefisOrganizationPage:
      benefisUIEvents.openEditBenefisOrganizationPage,
    openDeleteBenefisPage: benefisUIEvents.openDeleteBenefisPage,
    newBenefisOrganizationButtonClick:
      benefisUIEvents.newBenefisOrganizationButtonClick,
    openImportBenefisIndividuPage: benefisUIEvents.openImportBenefisIndividuPage,
    openImportBenefisOrganizationPage: benefisUIEvents.openImportBenefisOrganizationPage
  };

  return (
    <BenefisUIContext.Provider value={value}>
      {children}
    </BenefisUIContext.Provider>
  );
}
